import Tools from './../components/tools';

export default class Abonnement {
  constructor() {
    // Abonnement

    this.societe = document.querySelector('[name="ab_nom_societe"]');
    this.siren = document.querySelector('[name="ab_siret"]');
    this.nomCa = document.querySelector('[name="ab_nom_ca"]');
    this.prenomCa = document.querySelector('[name="ab_prenom_ca"]');
    this.fonctionCa = document.querySelector('[name="ab_fonction_ca"]');
    this.mailCa = document.querySelector('[name="ab_email_ca"]');
    this.telCa = document.querySelector('[name="ab_tel_ca"]');
    this.offreUn = document.querySelector('#ab_offre_1');
    this.offreDeux = document.querySelector('#ab_offre_2');

    this.formNextStep();
    this.formPreviousStep();
    this.offreSelected();
    this.validatePatterns();
  }

  formNextStep() {
    const nextBtn = document.querySelector('section article form .button-wrapper button.cta.next');
    const firstStep = document.querySelector('section article form .step[data-index="1"]');
    const secondStep = document.querySelector('section article form .step[data-index="2"]');
    const tabs = document.querySelector('section aside .tabs');

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();

        if (this.isFirstStepFilled()) {
          if (firstStep) {
            firstStep.classList.remove('active');
            tabs.children[0].classList.remove('active');
          }
          if (secondStep) {
            secondStep.classList.add('active');
            tabs.children[1].classList.add('active');
          }

          window.scrollTo({
            left: 0,
            top: Tools.offset( document.querySelector('aside') ).top,
            behavior: 'smooth',
          });
        } else {
          this.manageErrors();
        }
      });
    }
  }

  offreSelected() {
    const radios = document.querySelectorAll('input[name="ab_offre"]');
    if (radios.length > 0) {
      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          radios.forEach((elt) => {
            elt.nextElementSibling.querySelector('.cta').innerText = 'Je choisis cette offre';
          });
          if (radio.checked) {
            radio.nextElementSibling.querySelector('.cta').innerText = 'Offre choisie';
          }
        });
      });
    }
  }

  validatePatterns() {
    const inputs = document.querySelectorAll('form fieldset input[type="text"], form fieldset input[type="email"], form fieldset input[type="tel"]');
    if (inputs.length > 0) {
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (input.value != '') {
            input.parentElement.nextElementSibling.style.opacity = '1';
            if (input.parentElement.nextElementSibling.tagName == 'H3') {
              input.parentElement.nextElementSibling.nextElementSibling.style.opacity = '1';
            }
          }

          if (input.pattern != '') {
            const testPattern = new RegExp(input.getAttribute('pattern'));
            if (!testPattern.test(input.value)) {
              input.classList.add('error');
            } else {
              input.classList.remove('error');
            }
          }
        });
      });
    }
  }

  formPreviousStep() {
    const previousBtn = document.querySelector('section aside .tabs').children[0];
    const firstStep = document.querySelector('section article form .step[data-index="1"]');
    const secondStep = document.querySelector('section article form .step[data-index="2"]');
    const tabs = document.querySelector('section aside .tabs');

    if (previousBtn) {
      previousBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (firstStep) {
          firstStep.classList.add('active');
          tabs.children[0].classList.add('active');
        }
        if (secondStep) {
          secondStep.classList.remove('active');
          tabs.children[1].classList.remove('active');
        }
      });
    }
  }

  isFirstStepFilled() {
    if (this.societe.value !== '' && this.siren.value !== '' && this.nomCa.value !== '' && this.prenomCa.value !== '' && this.fonctionCa.value !== '' && this.mailCa.value !== '' && this.telCa.value !== '' && (this.offreUn.checked === true || this.offreDeux.checked === true)) {
      return true;
    } else {
      return false;
    }
  }

  manageErrors() {
    if (this.societe.value === '') {
      this.societe.classList.add('error');
    } else {
      this.societe.classList.remove('error');
    }

    this.societe.addEventListener('change', () => {
      if (this.societe.value === '') {
        this.societe.classList.add('error');
      } else {
        this.societe.classList.remove('error');
      }
    });

    if (this.siren.value === '') {
      this.siren.classList.add('error');
    } else {
      this.siren.classList.remove('error');
    }

    this.siren.addEventListener('change', () => {
      if (this.siren.value === '') {
        this.siren.classList.add('error');
      } else {
        this.siren.classList.remove('error');
      }
    });

    if (this.nomCa.value === '') {
      this.nomCa.classList.add('error');
    } else {
      this.nomCa.classList.remove('error');
    }

    this.nomCa.addEventListener('change', () => {
      if (this.nomCa.value === '') {
        this.nomCa.classList.add('error');
      } else {
        this.nomCa.classList.remove('error');
      }
    });

    if (this.prenomCa.value === '') {
      this.prenomCa.classList.add('error');
    } else {
      this.prenomCa.classList.remove('error');
    }

    this.prenomCa.addEventListener('change', () => {
      if (this.prenomCa.value === '') {
        this.prenomCa.classList.add('error');
      } else {
        this.prenomCa.classList.remove('error');
      }
    });

    if (this.fonctionCa.value === '') {
      this.fonctionCa.classList.add('error');
    } else {
      this.fonctionCa.classList.remove('error');
    }

    this.fonctionCa.addEventListener('change', () => {
      if (this.fonctionCa.value === '') {
        this.fonctionCa.classList.add('error');
      } else {
        this.fonctionCa.classList.remove('error');
      }
    });

    if (this.mailCa.value === '') {
      this.mailCa.classList.add('error');
    } else {
      this.mailCa.classList.remove('error');
    }

    this.mailCa.addEventListener('change', () => {
      if (this.mailCa.value === '') {
        this.mailCa.classList.add('error');
      } else {
        this.mailCa.classList.remove('error');
      }
    });

    if (this.telCa.value === '') {
      this.telCa.classList.add('error');
    } else {
      this.telCa.classList.remove('error');
    }

    this.telCa.addEventListener('change', () => {
      if (this.telCa.value === '') {
        this.telCa.classList.add('error');
      } else {
        this.telCa.classList.remove('error');
      }
    });

    if (this.offreUn.checked === false && this.offreDeux.checked === false) {
      document.querySelector('p.error').style.display = 'block';
    } else {
      document.querySelector('p.error').style.display = '';
    }

    this.offreUn.addEventListener('change', () => {
      if (this.offreUn.checked === false && this.offreDeux.checked === false) {
        document.querySelector('p.error').style.display = 'block';
      } else {
        document.querySelector('p.error').style.display = '';
      }
    });

    this.offreDeux.addEventListener('change', () => {
      if (this.offreUn.checked === false && this.offreDeux.checked === false) {
        document.querySelector('p.error').style.display = 'block';
      } else {
        document.querySelector('p.error').style.display = '';
      }
    });

    window.scrollTo({
      left: 0,
      top: Tools.offset( document.querySelectorAll('.error')[0] ).top - 50 - document.querySelector('nav').offsetHeight,
      behavior: 'smooth',
    });
  }
}